import * as React from "react";
import * as styles from "./sectionWithIcons.module.scss";
import parse from "html-react-parser";
import Container from "../../components/container/container";
import CustomLink from "../../components/customLink/CustomLink";
import SectionPattern from "../../svg/section-pattern.svg";
import SectionPatternDark from "../../svg/section-pattern-dark.svg";

const SectionWithIcons = ({
  sectionColor,
  titleMaxWidth,
  title,
  text,
  textSize,
  textColor,
  items,
  button,
}) => {
  const renderButtons = () => {
    if (button) {
      return (
        <div className={styles.sectionButton}>
          <CustomLink
            type={button.type}
            size={button.size}
            text={button.text}
            url={button.url}
            internal={button.internal}
          ></CustomLink>
        </div>
      );
    }
  };

  return (
    <section className={`${styles.section} ${styles[sectionColor]}`}>
      <div className={styles.sectionPattern}>
        {sectionColor === "green" ? <SectionPattern /> : <SectionPatternDark />}
      </div>
      <Container>
        <h2 style={{ maxWidth: titleMaxWidth }}>{parse(title)}</h2>
        {text && <p className={styles.additionalText} style={
        {
           color: textColor ? textColor : "initial",
           fontSize: textSize ? `${textSize} !important` : "initial"
          }
        }>{parse(text)}</p>}
        <div className={styles.iconsWrap}>
          {items.map((item, index) => {
            return (
              <div className={styles.iconsItem} key={index}>
                <div className={styles.iconsItemIcon}>{item.icon}</div>
                <h3>{item.title}</h3>
                {item.text && <p>{item.text}</p>}
              </div>
            );
          })}
        </div>
        {renderButtons()}
      </Container>
    </section>
  );
};

export default SectionWithIcons;
